const Scrollme = function(id){
    if(id != null){
      let des =  document.querySelector(id)
      const yCoordinate = des.getBoundingClientRect().top + window.pageYOffset;
      let yOffset = +100; 
      if(id === "#home"){
        yOffset = 0;
      }
      if(id === "#teaching"){
        yOffset = 9;
      }
      window.scrollTo({
        top: yCoordinate + yOffset,
        behavior: 'smooth'
      });
    }
  }

  export default Scrollme;